import React from 'react';
import { Root } from './style';

import { useState } from '@hookstate/core';
import ReactTooltip from 'react-tooltip';

const InfoBox = (props) => {
  const { className, style, info, children, open } = props;
  const foldable = props.open !== undefined;
  const state = useState(open);

  return (
    <Root
      className={`info-box ${className || ''}`}
      style={style || {}}
      onClick={() => state.set(!state.get())}>
      {
        foldable ?
          <div>
            <span className="mobile">{children}</span>
            <div className={`mobile info ${state.get() ? 'open' : ''}`}>{info}</div>
            <a className="desktop" data-tip={info} data-event="click focus">{children}</a>
            <ReactTooltip className="desktop tooltip" effect="solid" place="top" globalEventOff="click"/>
          </div> :
          <div>
            <a data-tip={info} data-event="click focus">{children}</a>
            <ReactTooltip className="tooltip" effect="solid" place="top" globalEventOff="click"/>
          </div>
      }
    </Root>
  );
};

export default InfoBox;
